(function () {
  'use strict';

  var upsellViewedFired = false;
  var upsellJourney = [];
  var upsellAddedMap = {};   // variant_id → { handle, title, position }
  var pendingUpsellRemoval = null;
  var mutationObserver = null;
  var intersectionObserver = null;

  function getUpsellFlag() {
    try {
      var raw = sessionStorage.getItem('ph_upsell_source');
      if (!raw) return null;
      var flag = JSON.parse(raw);
      if (Date.now() > flag.expires) {
        sessionStorage.removeItem('ph_upsell_source');
        return null;
      }
      return flag;
    } catch (e) {
      return null;
    }
  }

  function getCardTitle(qv) {
    var card = qv.closest('product-card');
    var link = card && card.querySelector('.cart-product-link');
    return link ? link.textContent.trim() : '';
  }

  // Reads the PostHog distinct_id regardless of whether the SDK has fully initialised.
  // The PostHog snippet creates window.posthog as a stub (truthy) immediately, but
  // get_distinct_id() only exists/returns a value after the async library loads.
  // We always fall through to the cookie so the add-to-cart fetch is never blocked
  // by a timing race between PostHog's async init and the user clicking the button.
  function getPhDistinctId() {
    if (window.posthog && typeof window.posthog.get_distinct_id === 'function') {
      var sdkId = window.posthog.get_distinct_id();
      if (sdkId) return sdkId;
    }
    try {
      var cookies = document.cookie.split('; ');
      for (var i = 0; i < cookies.length; i++) {
        var eqIdx = cookies[i].indexOf('=');
        var cookieName = cookies[i].slice(0, eqIdx);
        if (cookieName.indexOf('ph_') === 0 && cookieName.indexOf('_posthog') !== -1) {
          var raw = decodeURIComponent(cookies[i].slice(eqIdx + 1));
          var parsed = JSON.parse(raw);
          if (parsed.distinct_id) return parsed.distinct_id;
        }
      }
    } catch (e) {}
    return null;
  }

  function hasNetUpsellInCart() {
    var addCount = 0, removeCount = 0;
    for (var i = 0; i < upsellJourney.length; i++) {
      if (upsellJourney[i].action === 'add') addCount++;
      if (upsellJourney[i].action === 'remove') removeCount++;
    }
    return addCount > removeCount;
  }

  function fireUpsellViewed(container) {
    if (upsellViewedFired || !window.posthog) return;
    upsellViewedFired = true;

    var quickViews = container.querySelectorAll('quick-view[data-product-handle]');
    var handles = [];
    var titles = [];
    for (var i = 0; i < Math.min(quickViews.length, 4); i++) {
      handles.push(quickViews[i].getAttribute('data-product-handle'));
      titles.push(getCardTitle(quickViews[i]));
    }

    posthog.capture('cart_upsell_viewed', {
      recommendation_count: quickViews.length,
      recommended_product_handles: handles,
      recommended_product_titles: titles
    });
  }

  function checkUpsellVisibility(container) {
    if (upsellViewedFired) return;
    if (intersectionObserver) intersectionObserver.disconnect();

    intersectionObserver = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        intersectionObserver.disconnect();
        intersectionObserver = null;
        fireUpsellViewed(container);
      }
    }, { threshold: 0.5 });

    intersectionObserver.observe(container);
  }

  function observeUpsellLoad() {
    if (mutationObserver) {
      mutationObserver.disconnect();
      mutationObserver = null;
    }
    if (intersectionObserver) {
      intersectionObserver.disconnect();
      intersectionObserver = null;
    }

    var container = document.querySelector('.cart-drawer--recommendations--container');
    if (!container) return;

    if (container.classList.contains('product-recommendations--full')) {
      checkUpsellVisibility(container);
      return;
    }

    mutationObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].target.classList.contains('product-recommendations--full')) {
          mutationObserver.disconnect();
          mutationObserver = null;
          checkUpsellVisibility(mutations[i].target);
          return;
        }
      }
    });

    mutationObserver.observe(container, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Fetch interceptor — injects the line item property into /cart/add requests when the upsell flag is set.
  // This is more reliable than form injection (Event 4A) because it acts at the network layer,
  // regardless of DOM state or form re-renders between the quick-view open and submit.
  var _originalFetch = window.fetch;
  if (!window._cbpFetchWrapped) {
  window._cbpFetchWrapped = true;
  window.fetch = function (url, options) {
    var urlStr = typeof url === 'string' ? url : '';
    if (urlStr.indexOf('/cart/add') !== -1 && options && options.body instanceof FormData) {
      var flag = getUpsellFlag();
      if (flag && !options.body.has('properties[_CBP_cart_drawer_upsell]')) {
        options.body.append('properties[_CBP_cart_drawer_upsell]', 'true');
        var phId = getPhDistinctId();
        if (phId) options.body.append('properties[_CBP_ph_distinct_id]', phId);
      }
    }
    return _originalFetch.apply(this, arguments);
  };
  } // _cbpFetchWrapped guard

  // Event 1 — cart_opened
  document.addEventListener('cart-drawer:open', function () {
    upsellViewedFired = false;
    observeUpsellLoad();

    if (!window.posthog) return;
    var drawer = document.getElementById('Cart-Drawer');
    posthog.capture('cart_opened', {
      cart_item_count: drawer ? drawer.querySelectorAll('.product-cart-item').length : 0,
      source_page: window.location.pathname
    });
  });

  // Event 4B — cart_upsell_item_added
  document.addEventListener('cart:item-added', function (e) {
    var flag = getUpsellFlag();
    if (!flag) return;

    sessionStorage.removeItem('ph_upsell_source');

    var product = (e.detail && e.detail.product) || {};
    var variantId = String(product.variant_id || '');
    var handle = flag.product_handle;
    var title = product.title || flag.product_title || '';

    upsellJourney.push({
      action: 'add',
      handle: handle,
      product_title: title,
      variant_id: variantId,
      price: product.price || 0,
      position: flag.position
    });

    if (variantId) {
      upsellAddedMap[variantId] = { handle: handle, title: title, position: flag.position };
    }

    if (!window.posthog) return;
    posthog.capture('cart_upsell_item_added', {
      product_handle: handle,
      product_title: title,
      variant_id: variantId,
      price: product.price || 0,
      upsell_position: flag.position
    });
  });

  // Removal confirmation — fires after cart change fetch succeeds
  document.addEventListener('line-item:change:end', function (e) {
    if (!pendingUpsellRemoval) return;
    if (String(e.detail.quantity) !== '0') {
      pendingUpsellRemoval = null;
      return;
    }
    upsellJourney.push({
      action: 'remove',
      handle: pendingUpsellRemoval.handle,
      product_title: pendingUpsellRemoval.title,
      variant_id: pendingUpsellRemoval.variantId
    });
    pendingUpsellRemoval = null;
  });

  // Events 3 + 5 + removal detection — unified click listener
  document.addEventListener('click', function (e) {
    // Event 5 — checkout_button_clicked
    if (e.target.closest('#Cart-Drawer button.checkout-button')) {
      if (!window.posthog) return;

      // Write PostHog distinct_id to cart attributes before navigating to checkout.
      // Shopify persists cart attributes as note_attributes on the order — Gadget reads
      // this in upsellAttributionProcessor to fire upsell_item_purchased with the same ID,
      // enabling the P2-4 funnel to match guest sessions as well as logged-in sessions.
      var phId = posthog.get_distinct_id();
      if (phId) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { '_CBP_ph_distinct_id': phId } })
        }).catch(function () {});
      }

      var drawer = document.getElementById('Cart-Drawer');
      posthog.capture('checkout_button_clicked', {
        cart_item_count: drawer ? drawer.querySelectorAll('.product-cart-item').length : 0,
        has_upsell_item: hasNetUpsellInCart(),
        upsell_journey: upsellJourney,
        source: 'cart_drawer'
      });
      return;
    }

    // Removal detection — read item data while DOM still intact, before fetch re-renders
    var removeBtn = e.target.closest('#Cart-Drawer .remove');
    if (removeBtn) {
      var index = removeBtn.dataset.index;
      var cartItem = document.getElementById('CartDrawerItem-' + index);
      if (cartItem) {
        var qtySelector = cartItem.querySelector('quantity-selector[data-id]');
        if (qtySelector) {
          var variantId = qtySelector.getAttribute('data-id').split(':')[0];
          var entry = upsellAddedMap[variantId];
          if (entry) {
            var titleEl = cartItem.querySelector('.cart-product-link');
            pendingUpsellRemoval = {
              handle: entry.handle,
              title: titleEl ? titleEl.textContent.trim() : entry.title,
              variantId: variantId
            };
          }
        }
      }
      return;
    }

    // Event 3 — cart_upsell_item_clicked
    var qv = e.target.closest('.cart-drawer--recommendations quick-view');
    if (!qv) return;

    var handle = qv.getAttribute('data-product-handle') || '';
    var allQv = document.querySelectorAll('.cart-drawer--recommendations quick-view');
    var position = 1;
    for (var i = 0; i < allQv.length; i++) {
      if (allQv[i] === qv) { position = i + 1; break; }
    }

    var title = getCardTitle(qv);

    upsellJourney.push({ action: 'click', handle: handle, product_title: title, position: position });

    // Set flag unconditionally — the fetch interceptor depends on this regardless of posthog state
    sessionStorage.setItem('ph_upsell_source', JSON.stringify({
      source: 'cart_drawer',
      product_handle: handle,
      product_title: title,
      position: position,
      expires: Date.now() + 300000
    }));

    if (!window.posthog) return;
    posthog.capture('cart_upsell_item_clicked', {
      product_handle: handle,
      product_title: title,
      upsell_position: position,
      source: 'cart_drawer'
    });
  });

})();
